import { Component, Input } from "@angular/core";
import { CommonModule } from "@angular/common";

/**
 * Reusable section banner component for form steps
 * Provides consistent header styling across all steps
 */
@Component({
  selector: "app-section-banner",
  standalone: true,
  imports: [CommonModule],
  templateUrl: "./section-banner.component.html",
  styleUrl: "./section-banner.component.scss",
})
export class SectionBannerComponent {
  @Input() title!: string;
  @Input() subtitle?: string;
}
